function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useRef, useState } from 'react';
import raf from 'raf';
// NOTE: Adapted from https://github.com/jhonnold/react-animated-number
export const Counter = props => {
  var _formatValue, _formatValue2;

  const {
    value,
    initialValue = 0,
    duration = 250,
    formatValue,
    component: C = 'span',
    fps = 60
  } = props,
        rest = _objectWithoutProperties(props, ["value", "initialValue", "duration", "formatValue", "component", "fps"]);

  const [currentValue, setCurrentValue] = useState(initialValue);
  const previousValue = useRef(initialValue);
  const lastTimestamp = useRef(0);
  const startTimestamp = useRef(0);
  const handle = useRef();

  const shouldProcess = timestamp => !lastTimestamp.current || timestamp - lastTimestamp.current > 1000 / fps;

  const endAnimation = () => {
    if (handle.current) raf.cancel(handle.current);
  };

  const animate = (timestamp, reset) => {
    if (!shouldProcess(timestamp)) {
      handle.current = raf(animate);
      return;
    }

    const pValue = reset ? currentValue : previousValue.current;
    const sTimestamp = reset ? timestamp : startTimestamp.current;
    let nextValue;

    if (timestamp - sTimestamp >= duration) {
      nextValue = value; // Finish
    } else {
      const gap = value - pValue;
      const pctDuration = (timestamp - sTimestamp) / duration;
      nextValue = pValue + gap * pctDuration;
    }

    if (nextValue === value) {
      endAnimation();
      setCurrentValue(nextValue);
    } else {
      setCurrentValue(nextValue);
      previousValue.current = pValue;
      startTimestamp.current = sTimestamp;
      lastTimestamp.current = timestamp;
      handle.current = raf(animate);
    }
  };

  const startAnimation = () => {
    handle.current = raf(timestamp => {
      animate(timestamp, true);
    });
  };

  useEffect(() => {
    startAnimation();
    return () => endAnimation(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    endAnimation();
    startAnimation(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return /*#__PURE__*/React.createElement(C, rest, typeof window === 'undefined' ? (_formatValue = formatValue == null ? void 0 : formatValue(value)) != null ? _formatValue : value : (_formatValue2 = formatValue == null ? void 0 : formatValue(currentValue)) != null ? _formatValue2 : currentValue);
};
export default Counter;